import React from 'react';
import PropTypes from 'prop-types';
import {Alert} from '@tenancy.nz/ui';
import {Snackbar} from '@mui/material';

function Message({autoHideDuration, flash, text, onClose, type, show}) {
  const alert = (
    <Alert color={type} variant="standard" onClose={onClose}>
      {text}
    </Alert>
  );

  if (!flash && show) {
    return alert;
  }

  /** Snackbar only runs its auto-hide timer when an onClose handler is given */
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    onClose?.(event, reason);
  };

  return (
    <Snackbar
      color={type}
      open={show}
      autoHideDuration={autoHideDuration}
      onClose={onClose ? handleClose : undefined}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}>
      <div>{alert}</div>
    </Snackbar>
  );
}

Message.propTypes = {
  /**
   *
   */
  autoHideDuration: PropTypes.number,

  /**
   * If true, will show a message and the message box will disappear after few seconds
   */
  flash: PropTypes.bool,

  /**
   * The message to display
   */
  text: PropTypes.node.isRequired,

  /**
   * Callback function to call after close event is completed.
   */
  onClose: PropTypes.func,

  /**
   * Typically the color of the message box.
   */
  type: PropTypes.oneOf(['error', 'info', 'success', 'warning']),

  /**
   * If `true`, message box will be visible.
   */
  show: PropTypes.bool,
};

Message.defaultProps = {
  autoHideDuration: 8000,
  flash: false,
  onClose: undefined,
  type: 'error',
  show: false,
};

export default Message;
